import React from 'react';

interface Props {
  width?: string,
  height?: string,
  stroke?: string,
  className?: string,
}

const Exercise = ({
  width,
  height,
  stroke,
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 48 48"
    width={width}
    height={height}
    className={className}
    transform="scale(1.3)"
  >
    <g
      transform="translate(-.93 -1)"
      style={{
        fill: 'none',
        stroke,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 2,
      }}
    >
      <path
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeWidth="2"
        d="M13.975 28.02v4.33c0 .444.543.796 1.198.796h2.588c.664 0 1.208-.352 1.208-.795V17.649c0-.443-.544-.795-1.208-.795h-2.588c-.655 0-1.198.352-1.198.795z"
      />
      <path
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeWidth="2"
        d="M13.975 19.845h-3.796c-.665 0-1.199.352-1.199.785v8.74c0 .433.534.785 1.199.785h3.796z"
      />
      <path
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeWidth="2"
        d="M35.885 21.98v-4.33c0-.444-.543-.796-1.198-.796H32.1c-.664 0-1.208.352-1.208.795v14.702c0 .443.544.795 1.208.795h2.588c.655 0 1.198-.352 1.198-.795z"
      />
      <path
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeWidth="2"
        d="M35.885 30.155h3.796c.655 0 1.199-.352 1.199-.785v-8.74c0-.433-.544-.785-1.199-.785h-3.796z"
      />
      <path
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeWidth="2"
        d="M18.969 23.349H30.891000000000002V26.34H18.969z"
      />
    </g>
  </svg>
);

Exercise.defaultProps = {
  width: '48',
  height: '48',
  stroke: '#1a1818',
  className: 'Exercise',
};

export default Exercise;
